export default {
  avatarShape: {
    square: 'Quadratisch',
    round: 'Runde',
    roundedCorners: 'Abgerundete Ecken'
  },
  fontSize: {
    small: 'Klein',
    medium: 'Medium',
    large: 'Groß'
  },
  jobSeparator: {
    slash: '/',
    divide: '|',
    at: 'bei',
    newLine: 'Neue Linie'
  },
  type: {
    email: 'Email',
    link: 'Link',
    text: 'Text'
  }
}
